module.exports = __webpack_public_path__ + "static/media/garble1.7299925a.mp3";